import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"earth"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M11.9998 22C17.5226 22 21.9998 17.5228 21.9998 12C21.9998 11.6454 21.9813 11.2951 21.9453 10.95L19.9949 12.0839L16.4862 16.151L14.9825 13.1007L11.9751 12.0839V8.01678L8.96765 7L6.9627 9.03356L3.04978 7.55C2.51284 8.62877 2.15726 9.81824 2.04199 11.075L7.96517 13.1007L4.94978 19.1C6.74978 20.9 9.30455 22 11.9998 22Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2.04102 11.0886L7.9654 13.1007L4.94772 19.0898M3.04078 7.55301L6.96292 9.03356L8.96787 7L11.9753 8.01678V12.0839L14.9827 13.1007L16.4864 16.151L19.9951 12.0839L21.9389 10.9542M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z","strokeWidth":"props.strokeWidth"}}]}]};

const Earth = Vue.extend<IconProps>({
  name: 'EarthIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'earth',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Earth;
